import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { ExperienceCoursesService } from '../experience-courses.service';
import { ExperienceCoursesAcceleratorCourseFeedbackViewPart } from './accelerator-course-feedback/accelerator-course-feedback-view.part';
import { ExperienceCoursesAcceleratorEnrollmentsViewPart } from './accelerator-enrollments/accelerator-enrollments-view.part';
import { ExperienceCoursesCatalogViewPart } from './catalog/catalog-view.part';
import { ExperienceCoursesMonitoringViewPart } from './monitoring/monitoring-view.part';

@Component({
	selector: 'experience-courses-views-part',
	standalone: true,
	imports: [
		ExperienceCoursesCatalogViewPart,
		ExperienceCoursesMonitoringViewPart,
		ExperienceCoursesAcceleratorEnrollmentsViewPart,
		ExperienceCoursesAcceleratorCourseFeedbackViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './experience-courses-views.part.html',
})
export class ExperienceCoursesViewsPart implements OnInit {

	public service = inject(ExperienceCoursesService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}
